import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import moment from 'moment';

import styles from "./ConfirmDeleteModal.module.css";


function ConfirmDeleteModal(props) {
  
  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
    handleDeleteAll,
  } = props;

  const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);

  const targetNameInSingular = mode === 'notification' ? 'Notification' : 'Activity';
  const targetNameInPlural = mode === 'notification' ? 'Notifications' : 'Activities';

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    } else {
      handleDeleteAll();
    };
    onHide();
  };

  const handleCancel = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          { values ?
              <span>Delete {targetNameInSingular}</span>
            :
              <span>Delete All {targetNameInPlural}</span>
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        { values ?
          <>
            <p>Are you sure you want to delete the {targetNameInSingular.toLowerCase()} below?</p>
            <p>{values?.message}</p>
            <p>Received on: {values?.createdAt && moment(values.createdAt).format('DD MMM YYYY hh:mm a')}</p>
          </>
        :
          <>
            <p>Warning: this action cannot be undone.</p>
            <p>Are you sure you want to delete all {targetNameInPlural.toLowerCase()}?</p>
          </>
        }
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleAction}
            className={styles.actionButton}
          >
            Delete
          </button>
          <button
            onClick={handleCancel}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmDeleteModal; 